<template>
  <CampaignWine v-if="campaign.wine" :campaign-id="campaign.id" :name="`${campaignType} - ${month} ${year}`" />
  <CampaignWines v-else :campaign-id="campaign.id" :name="`Weingut des Monats - ${month} ${year}`" />
</template>

<script>
import { mapGetters } from 'vuex'
import CampaignWine from '@/components/campaigns/CampaignWine'
import CampaignWines from '@/components/campaigns/CampaignWines'

export default {
  components: {
    CampaignWine,
    CampaignWines,
  },
  async asyncData({ params }) {
    const slug = await params.slug
    return { slug }
  },
  computed: {
    ...mapGetters({
      getCampaign: 'campaign/getCampaignBySlugAndType',
    }),
    year() {
      return new Date(Date.parse(this.campaign.beginCampaign)).getFullYear()
    },
    month() {
      const date = new Date(Date.parse(this.campaign.beginCampaign))
      return date.toLocaleString('de-de', { month: 'long' })
    },
    campaignType() {
      return this.campaign.wine.type === 's' ? 'Sekt des Monats' : 'Wein des Monats'
    },
  },
  created() {
    this.campaign = this.getCampaign(this.slug, 'wine-of-month')
  },
}
</script>
